import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'


export interface DeliveryMatchError {
  level: string
  severity: 'error' | 'warning' | 'info'
  title: ReturnType<typeof t>
  description: ReturnType<typeof t> | null
}

export class RequestShipmentMethodsForBasketError implements DeliveryMatchError {
  level = 'root'
  severity = 'info' as const
  title: ReturnType<typeof t>
  description: ReturnType<typeof t> | null

  constructor() {
    this.title = t('request_shipment_methods_for_basket_error_title', { ns: 'csc-delivery-match', default: 'We are currently unable to connect with our delivery and pickup partners. ' })
    this.description = t('request_shipment_methods_for_basket_error_description', { ns: 'csc-delivery-match', default: 'Please try again shortly.' })
  }
}

export class UpdateShipmentMethodError implements DeliveryMatchError {
  level = 'method'
  severity = 'error' as const
  title: ReturnType<typeof t>
  description: ReturnType<typeof t> | null

  constructor() {
    this.title = t('update_shipment_method_error_title', { ns: 'csc-delivery-match', default: 'Failed to select delivery method' })
    this.description = t('update_shipment_method_error_description', { ns: 'csc-delivery-match', default: 'Try another method or try refreshing the page.' })
  }
}

export class SearchForDropOffLocationsError implements DeliveryMatchError {
  level = 'search'
  severity = 'warning' as const
  title: ReturnType<typeof t>
  description = null

  constructor() {
    this.title = t('search_for_dropoff_locations_error_title', { ns: 'csc-delivery-match', default: 'We couldn\'t find any locations. Please try again.' })
  }
}
